var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    true
      ? _c("div", { ref: "quan", staticClass: "container" }, [
          _c("div", {
            staticClass: "dot",
            class: [
              {
                onlineStyle: _vm.curStatus == 1,
                offlineStyle: _vm.curStatus == 0,
                alarmStyle: _vm.curStatus == 2
              }
            ],
            style: {
              width: typeof _vm.curStatus == "undefined" ? "28px" : "28px",
              height: typeof _vm.curStatus == "undefined" ? "28px" : "28px",
              backgroundSize: "100% 100%",
              background:
                _vm.curStatus == 0
                  ? "url(" + this.devLogUrl + ") no-repeat center center"
                  : _vm.curStatus == 2
                  ? "url(" + this.devLogUrlAle + ") no-repeat center center"
                  : _vm.curStatus == 1
                  ? "url(" + this.devLogUrlOff + ") no-repeat center center"
                  : typeof _vm.curStatus == "undefined"
                  ? "url(" +
                    require("../../../../../static/img/xunjian1.png") +
                    ") no-repeat center center"
                  : "transparent"
            },
            on: {
              mouseover: _vm.markOverHandler,
              mouseout: _vm.markOutHandle,
              click: _vm.markClickHandle
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c61b89d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c61b89d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/map/baseMap/quan.vue
// module id = null
// module chunks = 